module.exports = __webpack_public_path__ + "media/static/icons/icon-point--green-15d764c43ddd568c458147ce344c61ec.svg";